import { Layout } from '@faceup/ui-base'
import type { PropsWithChildren, ReactNode } from 'react'
import './assets/LegacyAdminLayout.css'

type LegacyAdminLayoutProps = PropsWithChildren<{
  menu: ReactNode
  header?: ReactNode
}>

export const LegacyAdminLayout = ({ children, menu, header }: LegacyAdminLayoutProps) => {
  return (
    <Layout className='h-screen w-screen not-print:min-w-[1100px] print:h-auto print:max-w-full print:overflow-x-hidden'>
      <Layout.Header className='h-[unset] p-0 leading-[unset]'>{header}</Layout.Header>
      <Layout>
        <Layout.Sider className='bg-colorDark print:hidden' collapsed collapsedWidth='64px'>
          {menu}
        </Layout.Sider>
        <Layout>
          <Layout.Content className='h-screen not-print:overflow-auto print:h-auto'>
            {children}
          </Layout.Content>
        </Layout>
      </Layout>
    </Layout>
  )
}
